import './style.css';

const WarningAlert = (
  title = "",
  text = "",
  confirmButtonText = "باشه",
  cancelButtonText = "انصراف",
  showCancelButton = true,
) => {
  return window.Swal.fire({
    title,
    text,
    icon: "warning",
    cancelButtonText,
    confirmButtonText,
    showCancelButton,
    // reverseButtons: true,
  });
};

export default WarningAlert;